import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
  Badge,
  Table,
} from "react-bootstrap";
import DataApi from "../../api/dataApi";
import PubSub from "pubsub-js";

const Settings = ({ permissions }) => {
  const [librarySettings, setLibrarySettings] = useState({
    max_books_per_card: 1,
    duration_days: 15,
    fine_per_day: 10,
    renew_limit: 2,
    max_issue_per_day: 1,
    lost_book_fine_percentage: 100,
    config_classification: "DDC",
    call_number_label: "Call Number",
    book_bank_plan: false,
    book_bank: false,
    book_bank_books_limit: 0,
  });
  //fetch company book_bank
  const [companySettings, setCompanySettings] = useState({
    book_bank: false,
  });

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [twoFactorAuth, setTwoFactorAuth] = useState("text");
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [isEditingSettings, setIsEditingSettings] = useState(false);
  const [tempSettings, setTempSettings] = useState({ ...librarySettings });


  console.log("permissions in LibrarySettings:", permissions);

  const canEditSettings = permissions?.allowEdit;


  console.log("canEditSettings", canEditSettings);
  console.log("isEditionSettings", isEditingSettings);

  useEffect(() => {
    fetchSettings();
    // fetchCompany();

  }, []);

  const fetchSettings = async () => {
    try {
      const settingsApi = new DataApi("librarysettings");
      const response = await settingsApi.get("/all");
      console.log("responseapi", response)
      if (response.data && response.data.success) {
        const settingsData = response.data.data;
        const settingsObj = {
          max_books_per_card: parseInt(settingsData.max_books_per_card || 1),
          duration_days: parseInt(settingsData.duration_days || 15),
          fine_per_day: parseInt(settingsData.fine_per_day || 10),
          renew_limit: parseInt(settingsData.renew_limit || 2),
          max_issue_per_day: parseInt(settingsData.max_issue_per_day || 1),
          lost_book_fine_percentage: parseInt(
            settingsData.lost_book_fine_percentage || 100
          ),
          config_classification: settingsData.config_classification,
          call_number_label: settingsData.call_number_label || "Call Number",
          book_bank: settingsData.book_bank,
          book_bank_books_limit: parseInt(settingsData.book_bank_books_limit),
          book_bank_plan: settingsData.book_bank_plan,
          // book_bank: settingsData.book_bank ,
          // book_bank_books_limit: parseInt(settingsData.book_bank_books_limit),
        };
        console.log(" ", settingsObj)
        setLibrarySettings(settingsObj);
      }
    } catch (error) {
      console.error('Error fetching settings:', error);

    }
  };
  // //company id
  // const getCompanyId = () => {
  //   const keys = Object.keys(localStorage);

  //   const userKey = keys.find(key => key.startsWith("prefetch:user"));

  //   console.log("keys", keys)
  //   console.log("userkeys", userKey)
  //   if (userKey) {
  //     const userData = JSON.parse(localStorage.getItem(userKey));
  //     return userData.companyid;
  //   }

  //   return null;
  // };
  // //fetch company
  // const fetchCompany = async () => {
  //   try {
  //     const companyId = getCompanyId();
  //     console.log("companyid", companyId)
  //     if (!companyId) return;

  //     const companyApi = new DataApi("company");
  //     const response = await companyApi.get(`/${companyId}`);


  //     console.log("company response", response)

  //     if (response.data) {
  //       console.log("book bank---->>", response.data.book_bank)
  //       setCompanySettings(response.data.book_bank);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching company:", error);
  //   }
  // };

  const handleSettingsEdit = () => {
    setIsEditingSettings(true);
    setTempSettings({ ...librarySettings });
  };

  const handleSettingsSave = async () => {
    try {
      const settingsApi = new DataApi('librarysettings');

      const settingsArray = [
        {
          setting_key: "max_books_per_card",
          setting_value: tempSettings.max_books_per_card.toString(),
        },
        {
          setting_key: "duration_days",
          setting_value: tempSettings.duration_days.toString(),
        },
        {
          setting_key: "fine_per_day",
          setting_value: tempSettings.fine_per_day.toString(),
        },
        {
          setting_key: "renew_limit",
          setting_value: tempSettings.renew_limit.toString(),
        },
        {
          setting_key: "max_issue_per_day",
          setting_value: tempSettings.max_issue_per_day.toString(),
        },
        {
          setting_key: "lost_book_fine_percentage",
          setting_value: tempSettings.lost_book_fine_percentage.toString(),
        },
        {
          setting_key: "config_classification",
          setting_value: tempSettings.config_classification,
        },
        {
          setting_key: "call_number_label",
          setting_value: tempSettings.call_number_label || "Call Number",
        },

        {
          setting_key: "book_bank",
          setting_value: tempSettings.book_bank ? "true" : "false",
        },
        {
          setting_key: "book_bank_books_limit",
          setting_value: tempSettings.book_bank_books_limit.toString(),
        },
        {
          setting_key: "book_bank_plan",
          setting_value: tempSettings.book_bank_plan ? "true" : "false",
        }
      ];

      const response = await settingsApi.put('/bulk', { settings: settingsArray });
      console.log("reposne->>>", response)
      if (response.data && response.data.success) {
        setLibrarySettings({ ...tempSettings });
        setIsEditingSettings(false);
        setAlertMessage("Library settings updated successfully!");
        setShowAlert(true);

        PubSub.publish('RECORD_SAVED_TOAST', {
          title: 'Success',
          message: 'Library settings updated successfully!'
        });
      } else {
        throw new Error("Failed to update settings");
      }
    } catch (error) {
      console.error("Error saving settings:", error);
      setAlertMessage("Failed to update settings. Please try again.");
      setShowAlert(true);

      PubSub.publish('RECORD_ERROR_TOAST', {
        title: 'Error',
        message: 'Failed to update library settings'
      });
    }
  };

  const handleSettingsCancel = () => {
    setIsEditingSettings(false);
    setTempSettings({ ...librarySettings });
  };
  const handleSettingChange = (key, value) => {
    console.log("value", value)
    console.log("temp", tempSettings.config_classification)
    // tempSettings.config_classification = value;
    setTempSettings((prev) => ({
      ...prev,
      [key]:
        typeof prev[key] === "number"
          ? parseInt(value) || 0
          : value,
    }));
  };
  // const handleSettingChange = (key, value) => {
  //   setTempSettings((prev) => ({
  //     ...prev,
  //     [key]: parseInt(value) || value,
  //   }));
  // };

  return (
    <Container fluid className=" detail-h4">
      <Row className="justify-content-center">
        <Col lg={12} xl={12}>
          <Card className="border-0 shadow-sm">
            <Card.Body>
              <div
                className="d-flex justify-content-between align-items-center mb-4 p-2"
                style={{
                  color: "var(--primary-color)",
                  background: "var(--primary-background-color)",
                  borderRadius: "10px",
                }}
              >
                <h5
                  className="fw-bold mb-1"
                  style={{ color: "var(--primary-color)" }}
                >
                  <i className="fa-solid fa-id-card me-2 fs-6"></i>
                  Setting Management
                </h5>
                {!isEditingSettings && (
                  <button
                    variant="primary"
                    onClick={handleSettingsEdit}
                    className={canEditSettings ? "custom-btn-table-header" : "disabled"}
                    disabled={!canEditSettings}
                    title={!canEditSettings ? "You don’t have permission to edit this. Please contact your administrator." : "Edit Settings"}
                  >
                    <i className="fa-solid fa-edit me-2"></i>
                    Edit Settings
                  </button>
                )}
                {isEditingSettings && (
                  <div>
                    <button
                      onClick={handleSettingsSave}
                      className="custom-btn-table-header me-2"
                    >
                      <i className="fa-solid fa-check me-2"></i>
                      Save
                    </button>
                    <button
                      onClick={handleSettingsCancel}
                      className="custom-btn-table-header btn-secondary"
                    >
                      <i className="fa-solid fa-xmark me-2"></i>
                      Cancel
                    </button>
                  </div>
                )}
              </div>
              <Row className="mt-4">
                <Col md={12} className="mb-4">
                  <h6
                    className="fw-bold mb-0 d-flex align-items-center justify-content-between p-3 border rounded"
                    style={{
                      color: "var(--primary-color)",
                      background: "var(--primary-background-color)",
                      borderRadius: "10px",
                    }}
                  >
                    Setting Information
                  </h6>
                </Col>
                <Row className="px-5">
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-semibold">
                        Maximum Books Per Card
                        <Badge bg="info" className="ms-2">
                          Current: {librarySettings.max_books_per_card}
                        </Badge>
                      </Form.Label>
                      {isEditingSettings ? (
                        <>
                          <Form.Control
                            type="number"
                            min="1"
                            max="10"
                            value={tempSettings.max_books_per_card}
                            onChange={(e) =>
                              handleSettingChange(
                                "max_books_per_card",
                                e.target.value
                              )
                            }
                            style={{
                              border: "2px solid #e9ecef",
                              borderRadius: "8px",
                              padding: "10px",
                            }}
                          />
                          <small className="text-muted d-block mt-1">
                            Maximum number of books that can be issued on one
                            Library Member
                          </small>
                        </>
                      ) : (
                        <div className="p-3 border rounded bg-light">
                          <span className="fw-bold text-primary">
                            {librarySettings.max_books_per_card} books
                          </span>
                          <small className="text-muted d-block mt-1">
                            Maximum number of books that can be issued on one
                            Library Member
                          </small>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-semibold">
                        Book Issue (Days)
                        <Badge bg="info" className="ms-2">
                          Current: {librarySettings.duration_days}
                        </Badge>
                      </Form.Label>
                      {isEditingSettings ? (
                        <>
                          <Form.Control
                            type="number"
                            min="1"
                            max="30"
                            value={tempSettings.duration_days}
                            onChange={(e) =>
                              handleSettingChange(
                                "duration_days",
                                e.target.value
                              )
                            }
                            style={{
                              border: "2px solid #e9ecef",
                              borderRadius: "8px",
                              padding: "10px",
                            }}
                          />
                          <small className="text-muted d-block mt-1">
                            Number of days a book can be issued for
                          </small>
                        </>
                      ) : (
                        <div className="p-3 border rounded bg-light">
                          <span className="fw-bold text-primary">
                            {librarySettings.duration_days} days
                          </span>
                          <small className="text-muted d-block mt-1">
                            Number of days a book can be issued for
                          </small>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-semibold">
                        Fine Per Day (₹)
                        <Badge bg="info" className="ms-2">
                          Current: ₹{librarySettings.fine_per_day}
                        </Badge>
                      </Form.Label>
                      {isEditingSettings ? (
                        <>
                          <Form.Control
                            type="number"
                            min="0"
                            max="100"
                            value={tempSettings.fine_per_day}
                            onChange={(e) =>
                              handleSettingChange(
                                "fine_per_day",
                                e.target.value
                              )
                            }
                            style={{
                              border: "2px solid #e9ecef",
                              borderRadius: "8px",
                              padding: "10px",
                            }}
                          />
                          <small className="text-muted d-block mt-1">
                            Fine amount for each day after due date
                          </small>
                        </>
                      ) : (
                        <div className="p-3 border rounded bg-light">
                          <span className="fw-bold text-primary">
                            ₹{librarySettings.fine_per_day} per day
                          </span>
                          <small className="text-muted d-block mt-1">
                            Fine amount for each day after due date
                          </small>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-semibold">
                        Renew Limit
                        <Badge bg="info" className="ms-2">
                          Current: {librarySettings.renew_limit}
                        </Badge>
                      </Form.Label>
                      {isEditingSettings ? (
                        <>
                          <Form.Control
                            type="number"
                            min="0"
                            max="5"
                            value={tempSettings.renew_limit}
                            onChange={(e) =>
                              handleSettingChange("renew_limit", e.target.value)
                            }
                            style={{
                              border: "2px solid #e9ecef",
                              borderRadius: "8px",
                              padding: "10px",
                            }}
                          />
                          <small className="text-muted d-block mt-1">
                            Maximum number of times a book can be renewed
                          </small>
                        </>
                      ) : (
                        <div className="p-3 border rounded bg-light">
                          <span className="fw-bold text-primary">
                            {librarySettings.renew_limit} times
                          </span>
                          <small className="text-muted d-block mt-1">
                            Maximum number of times a book can be renewed
                          </small>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-semibold">
                        Call Number Label
                        <Badge bg="info" className="ms-2">
                          Current: {librarySettings.call_number_label}
                        </Badge>
                      </Form.Label>
                      {isEditingSettings ? (
                        <>
                          <Form.Control
                            type="text"
                            value={tempSettings.call_number_label}
                            onChange={(e) =>
                              handleSettingChange("call_number_label", e.target.value)
                            }
                            style={{
                              border: "2px solid #e9ecef",
                              borderRadius: "8px",
                              padding: "10px",
                            }}
                          />
                          <small className="text-muted d-block mt-1">
                            {tempSettings.call_number_label && `Label used for ${tempSettings.call_number_label} column in book lists`}
                          </small>
                        </>
                      ) : (
                        <div className="p-3 border rounded bg-light">
                          <span className="fw-bold text-primary">
                            {librarySettings.call_number_label}
                          </span>
                          <small className="text-muted d-block mt-1">
                            {librarySettings.call_number_label && `Label used for ${librarySettings.call_number_label} column in book lists`}
                          </small>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-semibold">
                        Max Issues Per Day
                        <Badge bg="info" className="ms-2">
                          Current: {librarySettings.max_issue_per_day}
                        </Badge>
                      </Form.Label>
                      {isEditingSettings ? (
                        <>
                          <Form.Control
                            type="number"
                            min="1"
                            max="10"
                            value={tempSettings.max_issue_per_day}
                            onChange={(e) =>
                              handleSettingChange(
                                "max_issue_per_day",
                                e.target.value
                              )
                            }
                            style={{
                              border: "2px solid #e9ecef",
                              borderRadius: "8px",
                              padding: "10px",
                            }}
                          />
                          <small className="text-muted d-block mt-1">
                            Maximum books that can be issued in one day per user
                          </small>
                        </>
                      ) : (
                        <div className="p-3 border rounded bg-light">
                          <span className="fw-bold text-primary">
                            {librarySettings.max_issue_per_day} books/day
                          </span>
                          <small className="text-muted d-block mt-1">
                            Maximum books that can be issued in one day per user
                          </small>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-semibold">
                        Lost Book Fine (%)
                        <Badge bg="info" className="ms-2">
                          Current: {librarySettings.lost_book_fine_percentage}%
                        </Badge>
                      </Form.Label>
                      {isEditingSettings ? (
                        <>
                          <Form.Control
                            type="number"
                            min="0"
                            max="200"
                            value={tempSettings.lost_book_fine_percentage}
                            onChange={(e) =>
                              handleSettingChange(
                                "lost_book_fine_percentage",
                                e.target.value
                              )
                            }
                            style={{
                              border: "2px solid #e9ecef",
                              borderRadius: "8px",
                              padding: "10px",
                            }}
                          />
                          <small className="text-muted d-block mt-1">
                            Fine for lost books as percentage of book price
                          </small>
                        </>
                      ) : (
                        <div className="p-3 border rounded bg-light">
                          <span className="fw-bold text-primary">
                            {librarySettings.lost_book_fine_percentage}% of book
                            price
                          </span>
                          <small className="text-muted d-block mt-1">
                            Fine for lost books as percentage of book price
                          </small>
                        </div>
                      )}
                    </Form.Group>
                  </Col>


                  




                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label className="fw-semibold">
                        Classification
                        <Badge bg="info" className="ms-2">
                          Current: {librarySettings.config_classification}
                        </Badge>
                      </Form.Label>

                      {isEditingSettings ? (
                        <>
                          {/* <Form.Control
                            type="text"
                            min="0"
                            max="200"
                            value={tempSettings.config_classification }
                            onChange={(e) =>
                              handleSettingChange(
                                "config_classification",
                                e.target.value
                              )
                            }
                            style={{
                              border: "2px solid #e9ecef",
                              borderRadius: "8px",
                              padding: "10px",
                            }}
                          /> */}
                          <Form.Select
                            value={tempSettings.config_classification}
                            onChange={(e) =>
                              handleSettingChange("config_classification", e.target.value)
                            }
                            style={{
                              border: "2px solid #e9ecef",
                              borderRadius: "8px",
                              padding: "10px",
                            }}
                          >
                            <option value="DDC">DDC (Dewey Decimal Classification)</option>
                            <option value="LLC">LCC (Library of Congress Classification)</option>
                          </Form.Select>
                          <small className="text-muted d-block mt-1">
                            Fine for lost books as percentage of book price
                          </small>
                        </>
                      ) : (
                        <div className="p-3 border rounded bg-light">
                          <span className="fw-bold text-primary">
                            {librarySettings.config_classification}

                          </span>
                          <small className="text-muted d-block mt-1">
                            Library Organization System
                          </small>
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  {librarySettings.book_bank !== undefined && (
                    <>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label className="fw-semibold">
                            Book Limit
                            <Badge bg="info" className="ms-2">
                              Current: {librarySettings.book_bank_books_limit}
                            </Badge>
                          </Form.Label>



                          {isEditingSettings ? (
                            <>
                              <Form.Control
                                type="number"
                                min="0"
                                max="5"
                                value={tempSettings.book_bank_books_limit}
                                onChange={(e) =>
                                  handleSettingChange(
                                    "book_bank_books_limit",
                                    Number(e.target.value)
                                  )
                                }
                                style={{
                                  border: "2px solid #e9ecef",
                                  borderRadius: "8px",
                                  padding: "10px",
                                }}
                              />

                              <small className="text-muted d-block mt-1">
                                Maximum number of books allowed in book bank
                              </small>
                            </>
                          ) : (
                            <div className="p-3 border rounded bg-light">
                              <span className="fw-bold text-primary">
                                {librarySettings.book_bank_books_limit} books
                              </span>
                              <small className="text-muted d-block mt-1">
                                Maximum number of books allowed in book bank
                              </small>
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      {/* checkbox     */}
                      {/* <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label className="fw-semibold">
                            Book Bank
                            <Badge bg="info" className="ms-2">
                              Current: {librarySettings.book_bank ? "Yes" : "No"}
                            </Badge>
                          </Form.Label>
                          {isEditingSettings ? (
                            <>
                              <Form.Check
                                type="checkbox"
                                label="Enable Book Bank"
                                checked={tempSettings.book_bank || false}
                                onChange={(e) =>
                                  handleSettingChange("book_bank", e.target.checked)
                                }
                              />

                              <small className="text-muted d-block mt-1">
                                Enable or disable book bank facility
                              </small>
                            </>
                          ) : (
                            <div className="p-3 border rounded bg-light">
                              <span className="fw-bold text-primary">
                                {librarySettings.book_bank ? "Enabled" : "Disabled"}
                              </span>
                              <small className="text-muted d-block mt-1">
                                Book bank facility status
                              </small>
                            </div>
                          )}
                        </Form.Group>
                      </Col> */}
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label className="fw-semibold">
                            book_bank_plan
                            <Badge bg="info" className="ms-2">
                              Current: {librarySettings.book_bank_plan ? "Yes" : "No"}
                            </Badge>
                          </Form.Label>

                          {isEditingSettings ? (
                            <>
                              <Form.Check
                                type="checkbox"
                                label="Enable Book Bank Plan"
                                checked={tempSettings.book_bank_plan || false}
                                onChange={(e) =>
                                  handleSettingChange("book_bank_plan", e.target.checked)
                                }
                              />

                              <small className="text-muted d-block mt-1">
                                Enable or disable book bank plan
                              </small>
                            </>
                          ) : (
                            <div className="p-3 border rounded bg-light">
                              <span className="fw-bold text-primary">
                                {librarySettings.book_bank_plan ? "Enabled" : "Disabled"}
                              </span>
                              <small className="text-muted d-block mt-1">
                                Book bank plan status
                              </small>
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    </>
                  )}
                </Row>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Settings;
